<template>
    <div class="PDFViewer" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="PDFViewerBody" style="margin: auto;">
            <el-card class="card" v-for="i in numPages" :key="i" shadow="always">
                <pdf :src="pdfUrl" :page="i" :key="i" style="display: inline-block; width: 100%; height: 100%;"></pdf>
            </el-card>
        </div>
    </div>
</template>
<script>
    import pdf from "vue-pdf";
    import {Component, Vue} from "vue-property-decorator";
    import {imageUrl} from "../constants";
    @Component({
        name: "PDFViewer",
        components: {pdf}
    })
    export default class Home extends Vue {
        pdfUrl = "";
        fullscreenLoading = false;
        name = '';
        currentPage = 0;
        numPages = 0  //  pdf 文件总页数
        mounted() {
            this.getNumPages(this.$route.query.pdfurl);
        }
        getNumPages(url) {
            if(!url){
                this.$message.warning("未获取到参数，请重新进入！");
                return;
            }

            const pdfUrl = imageUrl + url;
            this.pdfUrl = pdfUrl; // 保存 PDF 文件的 URL
            this.fullscreenLoading = true; // 显示加载动画
              const loadingTask = pdf.createLoadingTask(pdfUrl);
              loadingTask.promise.then(pdf => {
                this.numPages = pdf.numPages; // 获取 PDF 的总页数
                this.fullscreenLoading = false; // 关闭加载动画
              }).catch((err) => {
                console.error("Failed to load PDF:", err); // 记录错误信息
                this.fullscreenLoading = false; // 关闭加载动画
              });
        }
    }
</script>

<style lang="scss">
    .PDFViewer{
        background-color: #3a3a3a;
        font-size: 16px;
        height: 100%;
        overflow: scroll;
    a {
        text-decoration: none;
    }
    .PDFViewerHeader{
        background-color:white;
        color: #3a3a3a;
        height: 60px;
        line-height: 60px;
    h1 {
        margin: 0;
        padding-left: 20px;
        font-size: 16px;
        height: 60px;
        line-height: 60px;
    }
    span {
        width: 100%;
        display: inline-block;
        text-align: center;
    }
    }
    .DownloadBtn{
        float: right;
    }
    .PDFViewerBody{
        text-align: center;
        padding: 2.2cm 2.5cm;
        width: 21cm;
    }
    .card {
        margin-bottom: 10px;
    }
    }
</style>